// extracted by mini-css-extract-plugin
module.exports = {"leftButton":"style_leftButton__3zCO9","rightButton":"style_rightButton__1Jmf4"};